// routes
import { PATH_DASHBOARD, PATH_ADMIN } from '../../../routes/paths';

import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;


const ICONS = {
  user: getIcon('ic_user'),
  dashboard: getIcon('Habukhan_home'),
  trans: getIcon('trans'),
  lock: getIcon('lock'),
  discount: getIcon('discount'),
  plan: getIcon('plan'),
  api: getIcon('api'),
  vend: getIcon('vend'),
  info: getIcon('info'),
  message: getIcon('message'),
  feature: getIcon('ads'),
  phone: getIcon('phone'),
  key: getIcon('key'),
  notif: getIcon('notif'),
  cal: getIcon('cal'),
  charity: getIcon('ic_analytics')
};

const adminConfig = [
  // smart user dashboard
  // ----------------------------------------------------------------------
  {
    subheader: 'general',
    items: [
      {
        title: 'dashboard',
        icon: ICONS.dashboard,
        children: [
          { title: 'admin dashboard', path: PATH_ADMIN.general.app },
          { title: 'user dashboard', path: PATH_DASHBOARD.general.app }
        ]
      },
      {
        title: 'customers',
        icon: ICONS.user,
        path: PATH_ADMIN.user.root,
        children: [
          { title: 'All Users',          path: PATH_ADMIN.user.all_user },
          { title: 'Standard Users',     path: PATH_ADMIN.user.smart_user },
          { title: 'VIP Users',          path: PATH_ADMIN.user.top_users },
          { title: 'API Users',          path: PATH_ADMIN.user.api_users },
          { title: 'Agent Users',        path: PATH_ADMIN.user.affiliate_users },
          { title: 'Referral Tracking',  path: PATH_ADMIN.user.referral_tracking },
          { title: 'Submitted User KYC', path: PATH_ADMIN.user.userskyc },
          { title: 'Credit/Debit User',  path: PATH_ADMIN.user.creditUser },
        ]
      },
      {
        title: 'Finances',
        icon: ICONS.trans,
        path: PATH_ADMIN.trans.root,
        children: [
          { title: 'Sales Statistics', path: PATH_ADMIN.trans.sales },
          { title: 'All Transactions', path: PATH_ADMIN.trans.history },
          { title: 'Failed Transactions', path: PATH_ADMIN.trans.failed },
          { title: 'Pending Transactions', path: PATH_ADMIN.trans.pending },
        ]
      },
      {
        title: 'Notification',
        icon: ICONS.notif,
        path: PATH_ADMIN.sendmessage.root,
        children: [
          { title: 'gmail notification', path: PATH_ADMIN.sendmessage.gmail },
          { title: 'system notification', path: PATH_ADMIN.sendmessage.system },
          { title: 'bulksms notification', path: PATH_ADMIN.sendmessage.bulksms }
        ]
      },
      // {
//         title: 'transaction calculator', icon: ICONS.cal, path: PATH_ADMIN.general.calculator
//       },
      // {
//         title: 'Charity Management', icon: ICONS.charity, path: PATH_ADMIN.general.charity
//       },
      {
        title: 'Support Management',
        icon: ICONS.message,
        path: PATH_ADMIN.general.support,
        children: [
          { title: 'Support Chat', path: PATH_ADMIN.general.support },
          { title: 'Vouchers', path: PATH_ADMIN.general.vouchers }
        ]
      }

    ],
  },
  {
    subheader: 'management',
    items: [
      {
        title: 'System Control',
        icon: ICONS.key,
        path: PATH_ADMIN.api.root,
        children: [

      {
        title: "Provider",
        icon: ICONS.api,
        path: PATH_ADMIN.api.root,
        children: [
          { title: 'Adex', path: PATH_ADMIN.api.adex },
          { title: 'MSORG', path: PATH_ADMIN.api.msorg },
          { title: 'OTHER', path: PATH_ADMIN.api.other },
          { title: 'WEB URL', path: PATH_ADMIN.api.web }
        ]
      },
      {
        title: 'Lock Services',
        icon: ICONS.lock,
        path: PATH_ADMIN.lock.root,
        children: [
          { title: 'Airtime', path: PATH_ADMIN.lock.airtime },
          { title: 'Data', path: PATH_ADMIN.lock.data },
          { title: 'Talkmore', path: PATH_ADMIN.lock.talkmore },
          { title: 'Cable', path: PATH_ADMIN.lock.cable },
          { title: 'Result Checker', path: PATH_ADMIN.lock.exam },
          { title: 'Data-Card', path: PATH_ADMIN.lock.data_card },
          { title: 'Recharge-Card', path: PATH_ADMIN.lock.recharge_card },
          { title: 'Bank Transfer Lock', path: PATH_ADMIN.lock.banks },
          { title: 'Single Bank Lock', path: PATH_ADMIN.lock.bank_list },
          { title: 'Virtual Accounts', path: PATH_ADMIN.lock.virtualaccounts },
          { title: 'Other Services', path: PATH_ADMIN.lock.other }
        ]
      },
      {
        title: 'Provider Selection',
        icon: ICONS.vend,
        path: PATH_ADMIN.selection.root,
        children: [
          { title: 'Data', path: PATH_ADMIN.selection.data },
          { title: 'Talkmore', path: PATH_ADMIN.selection.talkmore },
          { title: 'Airtime', path: PATH_ADMIN.selection.airtime },
          { title: 'Cable', path: PATH_ADMIN.selection.cable },
          { title: 'Bulksms', path: PATH_ADMIN.selection.bulksms },
          { title: 'Bill', path: PATH_ADMIN.selection.bill },
          { title: 'Result Checker', path: PATH_ADMIN.selection.exam },
          { title: 'Data-Card', path: PATH_ADMIN.selection.data_card },
          { title: 'Recharge-Card', path: PATH_ADMIN.selection.recharge_card },
          { title: 'Virtual Accounts', path: PATH_ADMIN.selection.virtualaccounts },
          { title: 'Bank Transfer', path: PATH_ADMIN.selection.transfer_settings },
          { title: 'Cash-Selection', path: PATH_ADMIN.selection.cash }
        ]
      },
      {
        title: 'Service Plans',
        icon: ICONS.plan,
        path: PATH_ADMIN.plan.root,
        children: [
          { title: 'Data Plans', path: PATH_ADMIN.plan.data },
          { title: 'Network Config', path: PATH_ADMIN.plan.network },
          { title: 'Talkmore Plans', path: PATH_ADMIN.plan.talkmore },
          { title: 'Cable Plans', path: PATH_ADMIN.plan.cable },
          { title: 'Bill Plans', path: PATH_ADMIN.plan.bill },
          { title: 'Result Checker', path: PATH_ADMIN.plan.exam },
          { title: 'Data-Card', path: PATH_ADMIN.plan.data_card_plan },
          { title: 'Recharge-Card', path: PATH_ADMIN.plan.recharge_card_plan }
        ]
      },
        ]
      },
      {
        title: 'discount / charges',
        icon: ICONS.discount,
        path: PATH_ADMIN.discount.root,
        children: [
          { title: 'airtime discount', path: PATH_ADMIN.discount.airtime },
          { title: 'cable charges', path: PATH_ADMIN.discount.cable },
          { title: 'bill charges', path: PATH_ADMIN.discount.bill },
          { title: 'airtime 2 cash discount', path: PATH_ADMIN.discount.cash },
          { title: 'result checker charges', path: PATH_ADMIN.discount.exam },
          { title: 'Bank Transfer Charges', path: PATH_ADMIN.discount.banks },
          { title: 'other services', path: PATH_ADMIN.discount.other },
          { title: '🎰 Spin & Win / Check-in', path: PATH_ADMIN.discount.gamification }
        ]
      },
      {
        title: 'System Setting',
        icon: ICONS.info,
        path: PATH_ADMIN.general.info,
        children: [
          { title: 'System info', path: PATH_ADMIN.general.info },
          { title: 'Welcome message', path: PATH_ADMIN.general.message },
          // { title: 'Ads message', path: PATH_ADMIN.general.ads },
          // { title: 'Feature Image', path: PATH_ADMIN.general.feature },
          // { title: 'Apps', path: PATH_ADMIN.general.app_download },
          { title: 'Payment Key', path: PATH_ADMIN.general.payment_key },
        ]
      },
    ]
  },

]
export default adminConfig;
